document.addEventListener('click', async (event) => {
  const button = event.target.closest('[data-copy-code]');
  if (!button) return;
  const status = button.parentElement.querySelector('[data-copy-status]');
  const label = button.querySelector('[data-copy-label]');
  try {
    await navigator.clipboard.writeText(button.dataset.copyCode);
    label.textContent = 'Copied';
    status.textContent = `Promo code ${button.dataset.copyCode} copied.`;
    window.setTimeout(() => { label.textContent = 'Copy code'; }, 2000);
  } catch (_error) {
    status.textContent = 'Could not copy the code. Select the code and copy it manually.';
  }
});
